/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .factory('UploadRequestCreateUpdateModal', [
        '$translate',
        '$rootScope',
        'modalAction',
        'SyncAndShareNode',
        function (
            $translate,
            $rootScope,
            modalAction,
            SyncAndShareNode
        ) {
            /**
             * Show modal window for creating/editing upload request
             * 
             * @param {SyncAndShareNode} target - Folder for which new upload request will be created
             * @param {object} [uploadRequest] - Upload request to edit, if empty, create a new upload request
             */
            return function (target, uploadRequest) {
                var modalScope = $rootScope.$new();
                var isEdit = angular.isObject(uploadRequest);
                var modalTitle = isEdit ?
                    'upload_requests_requested_files_actions_edit_request_title' :
                    'upload_requests_upload_modal_title';

                return modalAction(modalScope, {
                    modalController: 'UploadRequestCreateUpdateModalController',
                    modalClass: 'upload-request-dialog',
                    modalType: 'confirm',
                    modalTitle: $translate.instant(modalTitle),
                    modalSize: 'xl',
                    modalBodyTemplate: 'modals/actions/upload_request',
                    modalFooterTemplate: 'modals/actions/upload_request_footer',
                    resolve: {
                        target: function () {
                            return target;
                        },
                        uploadRequest: function () {
                            return uploadRequest || undefined;
                        },
                        isEdit: function () {
                            return isEdit;
                        }
                    }
                });
            };
        }]);

